<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-banner [pageTitle]="'wallet.page.title' | translate" />
  <fgb-mixed-loyalty-nav [walletPage]="true"></fgb-mixed-loyalty-nav>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <div class="barcode-container" (click)="$event.preventDefault(); $event.stopPropagation()">
    <div class="container-div">
      <fgb-page-header
        [pageTitle]="'wallet.page.title'"
        [backButtonLink]="'/'"
        [showBalance]="false"
        [showFooter]="false"
      ></fgb-page-header>
      <fgb-barcode
        [showMobileMenu]="false"
        [isWalletPage]="true"
        [memberDetails]="false"
        [showDiscountLevels]="true"
        (discountLevelVisibility)="setWalletHeight($event)"
      ></fgb-barcode>
    </div>
  </div>
</ng-container>

<div class="mobile-content-wrapper draggable-y" #draggableY>
  <div class="drag-wrapper" #dragPointer>
    <div class="drag-pointer"></div>
  </div>
  <div class="draggable-body" #draggableBody>
    <!-- Rewards Items -->
    <ng-container *ngIf="walletItems$ | async as walletItems">
      <div class="wallet-redeem-carousel mb-4">
        <div class="container">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div>
    </ng-container>

    <!-- Claimed Items -->
    <div class="container mb-4">
      <div class="claimed-rewards-card card flex-lg-row flex-column border">
        <div class="title-wrapper">
          <h5>{{ 'rewards.wallet.claimed.rewards.title' | translate }}</h5>
          <span class="subtitle">{{ 'rewards.wallet.claimed.rewards.description' | translate }}</span>
        </div>
        <a class="view-claimed-btn ms-auto border-black border rounded" [routerLink]="['/rewards/claimed']">
          {{ 'rewards.wallet.view.claimed' | translate }}
        </a>
      </div>
    </div>

    <div class="footer-wrapper mt-auto d-lg-none d-block">
      <fgb-footer></fgb-footer>
    </div>
  </div>
</div>
